import type { CityData } from '../types/city';

/** Fetch and parse the city.json data file */
export async function loadCityData(): Promise<CityData> {
  const response = await fetch('/data/city.json');
  if (!response.ok) {
    throw new Error(`Failed to load city data: ${response.status}`);
  }
  return response.json();
}
